import React, { FC } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { createStructuredSelector } from 'reselect'

import Cart from '../components/Cart'
import { sendLogisticsInfoOnShippingData } from '@/checkout-instore-legacy/shipping/actions'
import { actionCreators } from '../actions'
import {
  loadInStoreOrderForm,
  userPickedGifts,
} from '@/checkout-instore-legacy/order/actions'
import { loadInStoreVendor } from '@/checkout-instore-legacy/vendor/actions'
import { vendorSelector } from '@/checkout-instore-legacy/vendor/selectors'
import { actionCreators as searchActions } from '@/checkout-instore-legacy/search/actions'
import { actionCreators as rootModalActionCreators } from '@/checkout-instore-legacy/rootModal/actions'
import {
  clearLogisticsInfoCache,
  updateCartAddressWithSimulationAddress,
} from '@/checkout-instore-legacy/cart/simulation/actions'
import {
  externalCartSelector,
  cartStatusSelector,
  profileSelector,
  cartCodeSelector,
  queuedIncrementsSelector,
  openCartSelector,
  orderSelector,
  itemsSelector,
  askForceInHandsItemSelector,
  isLoadingSelector,
  waitingForGiftCardArrivalSelector,
  hasAtLeastOneValidItemSelector,
} from '../selectors'
import {
  cartMessagesSelector,
  cartMessageMapSelector,
} from '@/checkout-instore-legacy/cart/message/redux/selectors'
import useNetwork from '@/checkout-instore-legacy/hooks/useNetwork'

const CartContainer: FC = (props) => {
  const cartProps = {
    ...props,
    isOnline: useNetwork(),
  }

  return <Cart {...cartProps} />
}

export const mapStateToPropsSelector = createStructuredSelector({
  externalCart: externalCartSelector,
  cartStatus: cartStatusSelector,
  profile: profileSelector,
  cartCode: cartCodeSelector,
  queuedIncrements: queuedIncrementsSelector,
  openCart: openCartSelector,
  order: orderSelector,
  vendor: vendorSelector,
  items: itemsSelector,
  askForceInHandsItemState: askForceInHandsItemSelector,
  isLoading: isLoadingSelector,
  waitingForGiftCardArrival: waitingForGiftCardArrivalSelector,
  hasAtLeastOneValidItem: hasAtLeastOneValidItemSelector,
  cartMessages: cartMessagesSelector,
  cartMessageMap: cartMessageMapSelector,
})

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  ...bindActionCreators(actionCreators, dispatch),
  ...bindActionCreators({ sendLogisticsInfoOnShippingData }, dispatch),
  ...bindActionCreators({ loadInStoreOrderForm, userPickedGifts }, dispatch),
  ...bindActionCreators({ loadInStoreVendor }, dispatch),
  ...bindActionCreators(
    { clearLogisticsInfoCache, updateCartAddressWithSimulationAddress },
    dispatch
  ),
  ...bindActionCreators(rootModalActionCreators, dispatch),
  ...bindActionCreators(searchActions, dispatch),
})

export default connect(mapStateToPropsSelector, mapDispatchToProps, undefined, {
  pure: false,
})(CartContainer)
